import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { FavoritesProvider } from "./contexts/FavoritesContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import Admin from "./pages/Admin";
import ProductDrillDown from "./pages/ProductDrillDown";
import Generator from "./pages/Generator";
import Templates from "./pages/Templates";
import Profile from "./pages/Profile";
import Favorites from "./pages/Favorites";
import SharedProduct from "./pages/SharedProduct";
import Collections from "./pages/Collections";
import SharedCollection from "./pages/SharedCollection";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import RefundPolicy from "./pages/RefundPolicy";
import LicenseTerms from "./pages/LicenseTerms";
import SubscriptionTerms from "./pages/SubscriptionTerms";
import Contact from "./pages/Contact";
import TemplateCustomizer from "./pages/TemplateCustomizer";
import ProductPersonalizer from "./pages/ProductPersonalizer";
import PinterestStudio from "./pages/PinterestStudio";
import VerifyEmail from "./pages/VerifyEmail";
import CheckEmail from "./pages/CheckEmail";
import WeddingPlannerPage from "./pages/WeddingPlannerPage";
import Unsubscribe from "./pages/Unsubscribe";
import CookieConsent from "./components/CookieConsent";
import NewsletterPopup from "./components/NewsletterPopup";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();

  // Detect session_id in URL hash from Google OAuth callback
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/products/:slug" element={<ProductDrillDown />} />
      <Route path="/generator" element={<Generator />} />
      <Route path="/personalize" element={<ProductPersonalizer />} />
      <Route path="/customize" element={<TemplateCustomizer />} />
      <Route path="/pinterest-studio" element={<PinterestStudio />} />
      <Route path="/templates" element={<Templates />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/favorites" element={<Favorites />} />
      <Route path="/share/:shareId" element={<SharedProduct />} />
      <Route path="/collections" element={<Collections />} />
      <Route path="/collection/:shareId" element={<SharedCollection />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/cookies" element={<CookiePolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/license-terms" element={<LicenseTerms />} />
      <Route path="/subscription-terms" element={<SubscriptionTerms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/check-email" element={<CheckEmail />} />
      <Route path="/wedding-planner" element={<WeddingPlannerPage />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function AuthAwareNewsletterPopup() {
  const { user } = useAuth();
  return <NewsletterPopup isAuthenticated={!!user} />;
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <FavoritesProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
            <CookieConsent />
            <AuthAwareNewsletterPopup />
            <Toaster position="top-center" richColors closeButton />
          </BrowserRouter>
        </div>
      </FavoritesProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
